class SearchSuggestions {
  constructor(inputElement) {
    this.input = inputElement;
    this.form = inputElement.closest('form');
    this.container = null;
    this.isOpen = false;
    this.trendingSearches = this.getTrendingSearches();
    this.topProducts = this.getTopProducts();
    
    // Ensure form has relative positioning for absolute positioned dropdown
    if (this.form) {
      this.form.style.position = 'relative';
    }
    
    this.setupEventListeners();
  }

  getTrendingSearches() {
    const attr = this.input.getAttribute('data-trending-searches');
    if (!attr) return [];
    return attr.split('|').filter(s => s.trim());
  }

  getTopProducts() {
    const attr = this.input.getAttribute('data-top-products');
    if (!attr) {
      return [];
    }
    try {
      const parsed = JSON.parse(attr);
      return parsed;
    } catch (e) {
      console.error('Error parsing top products:', e, 'Raw attr:', attr);
      return [];
    }
  }

  setupEventListeners() {
    this.input.addEventListener('focus', () => this.handleFocus());
    this.input.addEventListener('input', () => this.handleInput());
    
    // Don't close on blur - only close on outside clicks
    document.addEventListener('click', (e) => {
      if (this.shouldClose(e.target)) {
        this.close();
      }
    });
    
    // Prevent closing when clicking inside the dropdown
    if (this.container) {
      this.container.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  }

  handleFocus() {
    // Only show suggestions if input is empty
    if (this.input.value.trim() === '') {
      this.open();
    }
  }

  handleInput() {
    // Close suggestions when user starts typing
    if (this.input.value.trim() !== '') {
      this.close();
      // Show reset button
      const resetBtn = this.form.querySelector('.reset__button');
      if (resetBtn) {
        resetBtn.classList.remove('hidden');
      }
    } else {
      // Hide reset button when input is empty
      const resetBtn = this.form.querySelector('.reset__button');
      if (resetBtn) {
        resetBtn.classList.add('hidden');
      }
    }
  }

  open() {
    if (this.isOpen) return;
    
    if (!this.container) {
      this.createContainer();
    }
    
    this.container.style.display = 'block';
    this.isOpen = true;
  }

  close() {
    if (this.container) {
      this.container.style.display = 'none';
    }
    this.isOpen = false;
  }

  shouldClose(target) {
    // Don't close if clicking inside the dropdown or form
    if (this.form && this.form.contains(target)) {
      return false;
    }
    if (this.container && this.container.contains(target)) {
      return false;
    }
    // Don't close if clicking on variant buttons, add to cart buttons, or quantity controls
    if (target.closest('.variant-button') || 
        target.closest('.atc-btn') || 
        target.closest('.card-quantity') ||
        target.closest('.quantity__button') ||
        target.closest('.quantity__input')) {
      return false;
    }
    return true;
  }

  createContainer() {
    this.container = document.createElement('div');
    this.container.className = 'search-suggestions-dropdown';
    this.container.innerHTML = this.buildHTML();
    this.form.appendChild(this.container);
    
    // Prevent closing when clicking inside the dropdown
    this.container.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    
    this.attachEventListeners();
  }

  buildHTML() {
    let html = '';

    // Trending Searches
    if (this.trendingSearches.length > 0) {
      html += `
        <div class="suggestions-section">
          <div class="suggestions-header">
            <svg class="trending-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 17"></polyline>
              <polyline points="17 6 23 6 23 12"></polyline>
            </svg>
            <h3>Trending Searches</h3>
            <button type="button" class="close-suggestions" aria-label="Close">×</button>
          </div>
          <div class="trending-searches">
      `;
      
      this.trendingSearches.forEach(search => {
        html += `
          <button type="button" class="trending-search-btn" data-search="${search}">
            <svg class="search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="23 6 13.5 15.5 8.5 10.5 1 17"></polyline>
              <polyline points="17 6 23 6 23 12"></polyline>
            </svg>
            ${search}
          </button>
        `;
      });
      
      html += `
          </div>
        </div>
      `;
    }

    // Top Products - Always show section if products are configured
    const productsContainer = document.querySelector('#search-suggestions-products');
    const hasProducts = productsContainer && productsContainer.querySelectorAll('.suggestion-product').length > 0;
    
    if (hasProducts) {
      const topProductsHeading = document.querySelector('[data-top-products-heading]')?.getAttribute('data-top-products-heading') || 'Top Products';
      html += `
        <div class="suggestions-section">
          <div class="suggestions-header">
            <svg class="star-icon" viewBox="0 0 24 24" fill="currentColor">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
            <h3>${topProductsHeading}</h3>
          </div>
          <div class="top-products" id="top-products-container">
            <!-- Products will be rendered here by JavaScript -->
          </div>
        </div>
      `;
    }

    return html;
  }

  attachEventListeners() {
    // Trending search buttons
    this.container.querySelectorAll('.trending-search-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const search = btn.getAttribute('data-search');
        this.input.value = search;
        this.form.submit();
      });
    });

    console.log("working");

    // Close button
    const closeBtn = this.container.querySelector('.close-suggestions');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.close());
    }

    // Render top products using PA-product-card
    this.renderTopProducts();
  }

  renderTopProducts() {
    const container = this.container.querySelector('#top-products-container');
    if (!container) {
      return;
    }

    // Get the hidden products container with server-rendered cards
    const productsContainer = document.querySelector('#search-suggestions-products');
    if (!productsContainer) {
      return;
    }

    // Move server-rendered products to the suggestions dropdown
    const suggestionProducts = productsContainer.querySelectorAll('.suggestion-product');
    
    if (suggestionProducts.length === 0) {
      return;
    }

    suggestionProducts.forEach((product, index) => {
      // Clone the entire form (which contains the product-card)
      let form = product.querySelector('form');
      
      // If form is not found, try to find and wrap the product-card
      if (!form) {
        const productCard = product.querySelector('.product-card');
        if (productCard) {
          // Create a form wrapper for the product card
          form = document.createElement('form');
          form.className = 'new-product-form';
          form.method = 'post';
          form.action = '/cart/add';
          
          // Get data from the hidden input if it exists
          const hiddenInput = product.querySelector('input[name="id"]');
          if (hiddenInput) {
            const variantId = hiddenInput.value;
            form.dataset.variants = '[]';
            form.dataset.sectionId = 'search-suggestions-' + index;
            form.dataset.productId = productCard.id.split('-').pop();
            
            const newHiddenInput = document.createElement('input');
            newHiddenInput.type = 'hidden';
            newHiddenInput.name = 'id';
            newHiddenInput.value = variantId;
            form.appendChild(newHiddenInput);
          }
          
          form.appendChild(productCard.cloneNode(true));
        }
      }
      
      if (form) {
        const clone = form.cloneNode(true);
        
        // Remove the initialized flag so it gets re-initialized
        clone.removeAttribute('data-initialized');
        
        // Wrap in a div for grid layout
        const wrapper = document.createElement('div');
        wrapper.className = 'top-product-wrapper';
        wrapper.appendChild(clone);
        container.appendChild(wrapper);
      }
    });

    // Initialize cart forms for the cloned products
    // Pass the container so it searches within it for forms
    if (typeof initCartForms === 'function') {
      // Use a small delay to ensure DOM is updated
      setTimeout(() => {
        initCartForms(container);
      }, 0);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const searchInputs = document.querySelectorAll('.search__input');
  searchInputs.forEach(input => {
    const hasTrendingSearches = input.getAttribute('data-trending-searches');
    const hasTopProducts = input.getAttribute('data-top-products');
    
    if (hasTrendingSearches || hasTopProducts) {
      new SearchSuggestions(input);
    }
  });
});
